'use client';

import { useMemo, useState } from "react";
import Image from "next/image";
import { UploadFile } from "@/app/lib/generated/graphql-types";
import {
    mediaRefAlt,
    mediaRefDimensions,
    mediaRefUrl
} from "@/app/features/shared/__to_be_integrated/types/general/media/media-helper";
import ImageModal from "@/app/features/shared/media-view/ui/shared/modal/ImageModal";
import styles from "./HistoryEventView.module.scss";

interface HistoryEventImageModalProps {
    image: UploadFile;
    eventTitle: string;
}

export default function HistoryEventImageModal({ image, eventTitle }: HistoryEventImageModalProps) {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const imageUrl = useMemo(() => mediaRefUrl(image, { size: "medium" }), [image]);
    const imageAlt = useMemo(() => mediaRefAlt(image) ?? "", [image]);
    const imageDimensions = useMemo(() => mediaRefDimensions(image), [image]);

    return (
        <>
            <figure className={`${styles.imageMotion} history-event-motion`}>
                <div className={`${styles.imageScaleMotion} history-event-motion`}>
                    <div className={styles.imageFrame}>
                        <button
                            type="button"
                            className={styles.imageButton}
                            aria-label={`Bild zu "${eventTitle}" vergrößert öffnen`}
                            aria-haspopup="dialog"
                            onClick={() => setIsModalOpen(true)}
                        >
                            <Image
                                src={imageUrl}
                                alt={imageAlt}
                                width={imageDimensions?.width ?? 600}
                                height={imageDimensions?.height ?? 800}
                                sizes="(min-width: 900px) 26vw, 92vw"
                                className={styles.image}
                            />
                        </button>
                    </div>
                </div>
            </figure>

            <ImageModal
                isOpen={isModalOpen}
                onClose={() => setIsModalOpen(false)}
                image={image}
                imageInfoEnabled
            />
        </>
    );
}
